<template>
  <span :class="getClass">
    <slot></slot>
    <BasicHelp v-if="helpMessage" :class="`${prefixCls}-help`" :text="helpMessage" />
  </span>
</template>
<script lang="ts" setup>
  import { computed, useSlots } from 'vue';
  import type { PropType } from 'vue';
  import { useDesign } from '@mts/hooks/web/useDesign';
  import BasicHelp from './BasicHelp.vue';

  const props = defineProps({
    /**
     * Help text list or string
     * @default: ''
     */
    helpMessage: {
      type: [String, Array] as PropType<string | string[]>,
      default: '',
    },
    /**
     * Whether the color block on the left side of the title
     * @default: false
     */
    span: { type: Boolean },
    /**
     * Whether to default the text, that is bold
     * @default: false
     */
    bold: { type: Boolean },
  });

  const { prefixCls } = useDesign('basic-title');
  const slots = useSlots();
  const getClass = computed(() => [
    prefixCls,
    { [`${prefixCls}-show-span`]: props.span && slots.default },
    { [`${prefixCls}-bold`]: props.bold },
  ]);
</script>
<style lang="less">
  @prefix-cls: ~'@{namespace}-basic-title';

  .@{prefix-cls} {
    display: flex;
    position: relative;
    color: @text-color-base;
    font-size: 16px;
    font-weight: 400;
    line-height: @line-height;
    cursor: pointer;
    user-select: none;

    &-bold {
      // font-size: 18px;
      font-weight: 500;
    }

    &-show-span {
      margin-bottom: 4px;
      padding-left: 7px;

      &::before {
        content: '';
        position: absolute;
        top: 4px;
        left: 0;
        width: 3px;
        height: 16px;
        margin-right: 4px;
        background-color: @primary-color;
      }
    }

    &-help {
      margin-left: 10px;
    }
  }
  .mts-pc .@{prefix-cls}-bold {
    font-size: 16px;
  }
</style>
